import findPathPattern from '@Navigation/findPathPattern';

export default function isPrivatePage(url: string) {
  const pattern = findPathPattern(url);

  return pattern.includes('/cabinet');
}
